<template>
  <div id="app" v-on:showmodal="handleModal">
    <router-view></router-view>
    <modals-container></modals-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    handleModal: function (value) {}
  },
  mounted () {
    // if (!document.getElementById('fr-init')) {
    //   var scriptTag = document.createElement('script')
    //   scriptTag.src = 'https://www.gstatic.com/firebasejs/6.3.4/firebase-app.js'
    //   scriptTag.id = 'fr-init'
    //   document.getElementsByTagName('head')[0].appendChild(scriptTag)
    // };
    // if (!document.getElementById('fr-ms-init')) {
    //   var scripttagg = document.createElement('script')
    //   scripttagg.src = 'https://www.gstatic.com/firebasejs/6.3.4/firebase-messaging.js'
    //   scripttagg.id = 'fr-ms-init'
    //   document.getElementsByTagName('head')[0].appendChild(scripttagg)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue